export default __webpack_public_path__ + "static/media/connect-hero.44c9c670.png";